function initTabs() {
  // Display the first tab-pane by default
  const firstTabPane = document.querySelector('.wp-tabs .tab-content .tab-pane:first-child');
  const firstNavItem = document.querySelector('.wp-tabs .wp-tabs-nav .nav-item:first-child');

  if (firstTabPane) {
    firstTabPane.style.display = 'block';
    firstTabPane.style.opacity = 1; // Ensure it's visible initially
  }

  if (firstNavItem) {
    firstNavItem.classList.add('current'); // Highlight the first nav-item
  }

  // Add click event listeners to the nav items for toggling
  document.querySelectorAll('.wp-tabs-nav .nav-item').forEach(function (tabControl) {
    tabControl.addEventListener('click', function (e) {
      const $this = e.currentTarget;
      const targetSelector = $this.getAttribute('data-target');
      const $target = document.querySelector(targetSelector);

      // Remove 'current' class from all nav-items
      $this.parentElement.querySelectorAll('.nav-item').forEach(function (sibling) {
        sibling.classList.remove('current');
      });

      // Hide all tab-panes
      $target.parentElement.querySelectorAll('.tab-pane').forEach(function (panel) {
        panel.style.display = 'none';
        panel.style.opacity = 0;
      });

      // Show and fade in the selected tab-pane
      $this.classList.add('current');
      if ($target) {
        $target.style.display = 'block';
        $target.style.opacity = 0;
        $target.style.transition = 'opacity 0.2s';
        setTimeout(function () {
          $target.style.opacity = 1;
        }, 10);
      }
    });
  });
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

// Debounce the tab initialization to handle Shopify events
const debouncedInitTabs = debounce(initTabs, 300);

document.addEventListener('shopify:section:load', debouncedInitTabs);
document.addEventListener('shopify:section:select', debouncedInitTabs);
document.addEventListener('shopify:section:deselect', debouncedInitTabs);
document.addEventListener('shopify:section:reorder', debouncedInitTabs);

// Initialize tabs on page load
initTabs();
